import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { GestionCrediticiaContent } from './components/GestionCrediticiaContent';

export default function GestionCrediticia() {
    return (
        <MainContent
            component={<GestionCrediticiaContent />}
            titulo='Gestión crediticia'
            noBackground
            tableMaxWidth
        />
    );

};
